import { SidebarPortal } from '@plone/volto/components';
import Sidebar from './Sidebar';
import { getParentUrl, addAppURL } from '@plone/volto/helpers';
import { toast } from 'react-toastify';
import { defineMessages, useIntl } from 'react-intl';
import { Toast } from '@plone/volto/components';
import { ButtonGroup } from '@designsystem/stories/03-molecules/ButtonGroup';

const messages = defineMessages({
  success: {
    id: 'Success',
    defaultMessage: 'Success',
  },
  messageCopied: {
    id: 'Link URL copied.',
    defaultMessage: 'Link URL copied.',
  },
  copyUrl: {
    id: 'URL Copy',
    defaultMessage: 'URL Copy',
  },
});

const AnchorBlockEdit = (props: any) => {
  const { data, onChangeBlock, block, selected, pathname } = props;
  let path = getParentUrl(pathname);
  path = addAppURL(path);
  const link = `${path}#${data.name}`;
  const intl = useIntl();

  const onCopy = () => {
    navigator.clipboard.writeText(link);
    toast.success(
      <Toast
        success
        title={intl.formatMessage(messages.success)}
        content={intl.formatMessage(messages.messageCopied)}
      />,
    );
  };

  return (
    <>
      <div className="page__section page__section--inline">
        <div className="page__section-content">
          <ButtonGroup
            size="small"
            items={[
              {
                type: 'secondary',
                label: intl.formatMessage(messages.copyUrl),
                icon: 'anchor',
                onClick: onCopy,
              },
              {
                type: 'tertiary',
                label: link,
                href: link,
              },
            ]}
          />
        </div>
      </div>
      <SidebarPortal selected={selected}>
        <Sidebar
          {...props}
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

export default AnchorBlockEdit;
